module.exports = __webpack_public_path__ + "img/hero-enterprise.c9ca83ba.jpg";